/* Catalogue Grid — image gallery controls (arrows + dot sync). */

(function () {
  function initGallery(card) {
    const track = card.querySelector('.catalogue-card__slides');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.catalogue-card__slide'));
    if (slides.length <= 1) return;

    const prev = card.querySelector('.catalogue-card__arrow--prev');
    const next = card.querySelector('.catalogue-card__arrow--next');
    const dots = Array.from(card.querySelectorAll('.catalogue-card__dot'));

    if (prev) prev.classList.add('is-enabled');
    if (next) next.classList.add('is-enabled');

    const scrollToIndex = (idx) => {
      const clamped = Math.max(0, Math.min(slides.length - 1, idx));
      track.scrollTo({ left: track.clientWidth * clamped, behavior: 'smooth' });
    };
    const currentIndex = () => Math.round(track.scrollLeft / track.clientWidth);

    if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); scrollToIndex(currentIndex() - 1); });
    if (next) next.addEventListener('click', (e) => { e.stopPropagation(); scrollToIndex(currentIndex() + 1); });

    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const idx = currentIndex();
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }, 50);
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.catalogue-card').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
